import React from 'react';
import './css/LoadingSpinner.scss'; 

const LoadingSpinner = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}

export default LoadingSpinner;
